"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canRenderRenewalSummaryTab = exports.canRenderCustomerSummaryTab = void 0;

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _BETDealUtils = require("crm_internal/utils/BETDealUtils");

var canRenderCustomerSummaryTab = function canRenderCustomerSummaryTab(_ref) {
  var objectType = _ref.objectType,
      subject = _ref.subject;
  return _ScopesContainer.default.isScoped('bet-customer-summary-access') && (objectType === _ObjectTypes.DEAL && (0, _BETDealUtils.isCustomerSummaryEnabledPipeline)(subject) || objectType === _ObjectTypes.COMPANY);
};

exports.canRenderCustomerSummaryTab = canRenderCustomerSummaryTab;

var canRenderRenewalSummaryTab = function canRenderRenewalSummaryTab(_ref2) {
  var objectType = _ref2.objectType,
      subject = _ref2.subject;
  return objectType === _ObjectTypes.DEAL && _ScopesContainer.default.isScoped('bet-renewal-summary-access') && (0, _BETDealUtils.isRenewalDealPipeline)(subject);
};

exports.canRenderRenewalSummaryTab = canRenderRenewalSummaryTab;